import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { PAGES } from "../../../consts/CommonV2";
import { ROUTES } from "../../../consts/Common";
import { TEAM } from "../../../consts/DBFields";
import { useAppContext } from "../../../contexts/Core";
import Configs from "../../../Configurations";
import "./SideMenu.scss";

const QA_ID_PREFIX = `Sidemenu`;

function SideMenu() {
  const history = useHistory();
  const location = useLocation()
  const { isToggleEnabled, selectedTeam } = useAppContext();
  const [selectedPage, setSelectedPage] = useState(0);

  useEffect(() => {
    const pathname = location.pathname;
    if(pathname === "/" || pathname === "/folders" || pathname === "/folders/") {
      setSelectedPage(0);
    } else if(pathname.startsWith("/analytics")) {
      setSelectedPage(2);
    } else if(pathname.startsWith("/report")) {
      setSelectedPage(3);
    } else if(pathname.startsWith("/recipients")) {
      setSelectedPage(4);
    } else if(pathname.startsWith("/templates")) {
      setSelectedPage(5);
    } else if(pathname.startsWith("/folders/media")) {
      setSelectedPage(6);
    } else if(pathname.startsWith("/help")) {
      setSelectedPage(7);
    }
  }, [location.pathname]);

  return (
    <>
      <div
        className="sidemenu-container"
        data-testid={`${QA_ID_PREFIX}-container`}
      >
        {Object.keys(PAGES).map((opt, idx) => {
          if (
            !PAGES[opt].disabled &&
            (!PAGES[opt].toggle || isToggleEnabled(PAGES[opt].toggle))
          ) {
            return (
              <div
                key={PAGES[opt].label}
                className={selectedPage === idx ? "sidemenu-item-selected" : ""}
                onClick={() => setSelectedPage(idx)}
              >
                <div
                  className="sidemenu-item"
                  data-testid={`${QA_ID_PREFIX}-item-${PAGES[opt].label}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (PAGES[opt].isExternal) {

                      // Guard against a missing config value — otherwise a relative
                      // string like "undefined/teams" is opened and the browser resolves
                      // it against the current path (e.g. /folders/undefined/teams).
                      const baseUrl = Configs.REACT_APP_SPARK_COMMS_URL;
                      if (!baseUrl) {
                        console.error(
                          "[SideMenu] REACT_APP_SPARK_COMMS_URL is not configured; " +
                            "cannot navigate to external page:",
                          opt
                        );
                        return;
                      }
                      const externalUrl = `${baseUrl}/${opt.toLowerCase()}`;
                      window.location.href = externalUrl;
                    } else if (PAGES[opt].route) {
                      const teamId = selectedTeam?.[TEAM.ID];
                      const route = PAGES[opt].route === ROUTES.ANALYTICS
                        ? `/${ROUTES.TEAM}/${teamId}/${ROUTES.ANALYTICS}`
                        : `/${PAGES[opt].route}`;
                      history.push(route);
                    }
                  }}
                >
                  <div
                    className="sidemenu-icon"
                    data-testid={`${QA_ID_PREFIX}-icon-${opt}`}
                  >
                    {PAGES[opt].icon}
                  </div>
                  <div
                    className="sidemenu-label"
                    data-testid={`${QA_ID_PREFIX}-label-${opt}`}
                  >
                    {PAGES[opt].label}
                  </div>
                </div>
              </div>
            );
          }
          // return <Tab style={{ display: "none" }} />;
        })}
      </div>
    </>
  );
}

export default SideMenu;
